type TimeSeriesDataPoint = [number, (number | undefined)?, (number | undefined)?];

/**
 * Find the variable with the lowest sample rate from the given list.
 */
export function findLowestSampleRateVariable<T extends { sampleRate: number }>(variables: T[]) {
  if (!variables.length) return undefined;
  return variables.reduce((lowest, curr) => {
    if (curr.sampleRate < lowest.sampleRate) return curr;
    return lowest;
  });
}

/**
 * Find the value at the data point whose timestamp is closest to targetMillis.
 */
export function findClosestValueInTimeSeries(data: TimeSeriesDataPoint[] | undefined, targetMillis: number) {
  if (!data?.length) return undefined;
  return data.reduce((closest, current) => {
    const [currentTime] = current;
    const [closestTime] = closest;
    return Math.abs(currentTime - targetMillis) < Math.abs(closestTime - targetMillis) ? current : closest;
  })[1];
}
